function SistemaIndisponivelView() {
  return (
    <div style={{ textJustify: 'auto', alignContent: 'center', alignItems: 'center' }}>
      Sistema Indisponível. Entre em contato com o administrador para mais informações.
    </div>
  );
}

export default SistemaIndisponivelView;
